import { JOURNEY_UNAVAILABLE_ENGLISH, getJourneyInfoSupplement } from '../data/journeyInfoSupplementTranslations.js';
import { professionalTranslationFor } from '../data/professionalTranslationRuntime.js';
import { sourceRevision } from './translationAssurance.js';

// This patient state is rendered by both configurable and generic Journey
// routes, but the older 16-language fallback lives outside locale JSON.
export function buildJourneyUnavailableTranslationRows(locale) {
  const code = String(locale || 'en').toLowerCase().split('-')[0];
  const localized = getJourneyInfoSupplement(code);
  const names = { title: 'journeyUnavailableTitle', body: 'journeyUnavailableBody', action: 'journeyUnavailableAction' };
  return Object.entries(JOURNEY_UNAVAILABLE_ENGLISH).map(([path, sourceText]) => {
    const id = 'journeyUnavailable:' + path;
    return {
      id, namespace: 'journeyUnavailable', path, contentArea: 'hospital_journeys',
      sourceText, sourceRevision: sourceRevision(id, sourceText),
      originalText: localized?.[names[path]] || (code === 'en' ? sourceText : ''),
      provenance: professionalTranslationFor(code, 'journeyUnavailable', path)
        ? 'professionally approved correction' : code === 'en'
          ? 'English Journey fallback source' : 'legacy Journey information language pack',
      publicationTarget: 'locale',
    };
  });
}
